// extracted by mini-css-extract-plugin
module.exports = {"ribbon_holder":"Ribbon_ribbon_holder__8o5lp","ribbon":"Ribbon_ribbon__nh_d4","orange":"Ribbon_orange__1relT","small":"Ribbon_small__KWypL"};